export const testStatuses = [
    {
        name: 'Новый',
        value: 'new',
    },
    {
        name: 'Начат',
        value: 'started',
    },
    {
        name: 'Отменен',
        value: 'canceled',
    },
    {
        name: 'Завершен',
        value: 'finished',
    },
]

export const trueFalseValues = [
    {
        name: 'Да',
        value: "true",
    },
    {
        name: 'Нет',
        value: "false",
    },
]

export const periods = [
    {
        name: 'Сегодня',
        value: 'today',
    },
    {
        name: 'Вчера',
        value: 'yesterday',
    },
    {
        name: 'Прошлая неделя',
        value: 'past_week',
    },
    {
        name: 'Текущая неделя',
        value: 'week'
    },
    {
        name: 'Прошлый месяц',
        value: 'past_month'
    },
    {
        name: 'Текущий месяц',
        value: 'month'
    },
    {
        name: 'Прошлый квартал',
        value: 'past_quarter'
    },
    {
        name: 'Текущий квартал',
        value: 'quarter'
    },
    {
        name: 'Прошлый год',
        value: 'past_year'
    },
    {
        name: 'Текущий год',
        value: 'year'
    }
]

export const weekdays = [
    {name: 'Пн', value: "1"},
    {name: 'Вт', value: "2"},
    {name: 'Ср', value: "3"},
    {name: 'Чт', value: "4"},
    {name: 'Пт', value: "5"},
    {name: 'Сб', value: "6"},
    {name: 'Вс', value: "0"}
]

export const frequencies = [
    {
        name: 'Ежедневно',
        value: 'day'
    },
    {
        name: 'Еженедельно',
        value: 'week'
    },
    {
        name: 'Ежемесячно',
        value: 'month'
    }
]

export const sorts = [
    {
        name: 'По времени',
        value: 'time'
    },
    {
        name: 'По направлению',
        value: 'direction'
    },
]